/**
 * TravparkLogo - Always shows the original Sørlandets Travpark logo.
 * Props sommertravetMode/animated are accepted but ignored (theme handled elsewhere).
 */
export function TravparkLogo({ height = 64, sommertravetMode = false, animated = false, style = {} }) {
  return (
    <img
      src="/sorlandet-logo.png"
      alt="Sørlandets Travpark"
      data-testid="travpark-logo"
      style={{
        height,
        objectFit: 'contain',
        ...style,
      }}
    />
  );
}
